import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { Text } from '@chakra-ui/react'

function WizardForbiddenMessage() {
  const { insuranceParams, insuranceParamsId: paramsId, error } = useInsuranceParams()

  if ((!paramsId || !insuranceParams) && error?.response?.status === 403)
    return (
      <Text variant='warning' textAlign='center' my={8}>
        Na zobrazení nabídky nemáte dostatečná oprávnění
      </Text>
    )

  return null
}

export default WizardForbiddenMessage